var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content has-text-centered"},[_c('success'),(_vm.pending)?_c('div',[_vm._v(_vm._s(_vm.$t("safe_charged_success_message")))]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }